import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ModalController } from "@ionic/angular";
import { LoveItAlertService } from "../../services/love-it-alert.service";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { MailmanagerDeleteSieveRequest } from "../../../api/models/mailmanager-delete-sieve-request";
import { MailmanagerListSieveResponse } from "../../../api/models/mailmanager-list-sieve-response";
import { MailmanagerSieveFilter } from "../../../api/models/mailmanager-sieve-filter";
import { MailmanagerUserIdRequest } from "../../../api/models/mailmanager-user-id-request";
import { MailmanagerService } from "../../../api/services/mailmanager.service";
import { EmailAbwesenheitsbenachrichtigungComponent } from "../email-abwesenheitsbenachrichtigung/email-abwesenheitsbenachrichtigung.component";

@Component({
  selector: "app-email-abwesenheitsbenachrichtigung",
  templateUrl: "./email-abwesenheitsbenachrichtigungen-list.component.html",
  styleUrls: ["./email-abwesenheitsbenachrichtigungen-list.component.scss"],
  standalone: false,
})
export class EmailAbwesenheitsbenachrichtigungenListComponent implements OnInit, AfterViewInit {
  @Input({ required: true })
  userId: string;
  isSaving: boolean = false;
  loadSieveFilters: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ["from", "to", "actions"];
  dataSourceMatTable: MatTableDataSource<any>;
  userData;

  constructor(
    private modalController: ModalController,
    private oidcSecurityService: OidcSecurityService,
    private mailmanagerService: MailmanagerService,
    private loveItAlertService: LoveItAlertService,
  ) {
    this.dataSourceMatTable = new MatTableDataSource([]);
  }

  ngOnInit() {
    this.oidcSecurityService.userData$.subscribe((userData) => {
      this.userData = userData;
    });
    this.updateSieveFilterList();
  }

  ngAfterViewInit() {
    this.dataSourceMatTable.sort = this.sort;
  }

  updateSieveFilterList() {
    this.loadSieveFilters = true;
    this.dataSourceMatTable.data = [];
    this.mailmanagerService
      .mailmanagerSieveRetrieveCreate({
        token: this.oidcSecurityService.getToken(),
        user_id: this.userId,
      } as MailmanagerUserIdRequest)
      .subscribe({
        next: (response: MailmanagerListSieveResponse) => {
          this.dataSourceMatTable.data = response.filters;
          this.loadSieveFilters = false;
        },
        error: async (error) => {
          this.loadSieveFilters = false;
        },
      });
  }

  deleteSieveFilter(filter: MailmanagerSieveFilter) {
    this.mailmanagerService
      .mailmanagerSieveDeleteCreate({
        token: this.oidcSecurityService.getToken(),
        user_id: this.userId,
        filter_id: filter.id,
      } as MailmanagerDeleteSieveRequest)
      .subscribe({
        next: (response) => {
          this.updateSieveFilterList();
        },
        error: async (error) => {},
      });
  }

  async deleteSieveFilterDialogAnzeigen(filter: MailmanagerSieveFilter) {
    await this.showOnlySieveChangesAlert(filter);
    const alert = await this.loveItAlertService.create({
      header: "Abwesenheitsbenachrichtigung löschen?",
      message: "Die Abwesenheitsbenachrichtigung ist nach dem Löschen nicht mehr verfügbar.",
      buttons: [
        {
          cssClass: "color-primary",
          text: "Abbrechen",
          role: "cancel",
        },
        {
          cssClass: "color-danger",
          text: "Löschen",
          handler: () => {
            this.deleteSieveFilter(filter);
          },
        },
      ],
    });

    await alert.present();
  }

  cancelButton() {
    this.modalController.dismiss(null, "cancel");
  }

  submit() {
    this.isSaving = false;
    this.modalController.dismiss(null, "confirm");
  }

  onDatatableActivate(event: any, row) {
    if (event.target.id === "delete-sieve-filter-button" || event.target.id === "edit-sieve-filter-button") {
      return;
    }

    this.openEmailAbwesenheitsbenachrichtigungModal(row);
  }

  async openEmailAbwesenheitsbenachrichtigungModal(existingSieveFilter?: MailmanagerSieveFilter) {
    if (!this.userData) {
      return;
    }
    if (existingSieveFilter) {
      await this.showOnlySieveChangesAlert(existingSieveFilter);
    }
    const modal = await this.modalController.create({
      component: EmailAbwesenheitsbenachrichtigungComponent,
      cssClass: "bigger-modal",
      backdropDismiss: false,
      componentProps: {
        userId: this.userId,
        userData: this.userData,
        existingSieveFilter: existingSieveFilter,
      },
    });

    modal.onDidDismiss().then((data) => {
      const d = data.data;
      if (data?.role === "confirm") {
        this.updateSieveFilterList();
      }
    });

    await modal.present();
  }

  async showOnlySieveChangesAlert(filter: MailmanagerSieveFilter) {
    if (!filter?.saved_sieve_filter?.notify_backoffice) {
      return;
    }
    const alert = await this.loveItAlertService.create({
      header: "Die Daten wurden bereits an das Backoffice übermittelt",
      message: `Wenn die Abwesenheit bearbeitet wird, gilt dies nur für die automatischen Antworten bei E-Mail Empfang. Das Backoffice muss – sofern relevant – über die Änderung gesondert per E-Mail an office@faircheck.at informiert werden.`,
      buttons: [
        {
          cssClass: "color-success",
          text: "Verstanden",
          role: "cancel",
        },
      ],
    });

    await alert.present();
    await alert.onDidDismiss();
  }
}
